/* ============================================
   Archivo: assets/collection-carousel.js
   Lógica de navegación del carrusel
   ============================================ */

(function () {
  document.querySelectorAll('.collection-carousel__wrapper').forEach(function (wrapper) {
    const track = wrapper.querySelector('.collection-carousel__track');
    const btnPrev = wrapper.querySelector('.collection-carousel__btn--prev');
    const btnNext = wrapper.querySelector('.collection-carousel__btn--next');

    if (!track || !btnPrev || !btnNext) return;

    // Cuántos px desplazar por clic (ancho de ~2 items)
    const scrollAmount = 320;

    btnPrev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    btnNext.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    // Actualizar visibilidad de botones según posición del scroll
    function updateButtons() {
      btnPrev.classList.toggle('is-hidden', track.scrollLeft <= 0);
      btnNext.classList.toggle(
        'is-hidden',
        track.scrollLeft + track.clientWidth >= track.scrollWidth - 1
      );
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    // Estado inicial
    updateButtons();
  });
})();